import navigation from "../components/navigation/navigation.js";
import footer from "../components/footer/footer.js";
import siteSettings from "../settings/site-settings.js";
import docsSettings from "../settings/docs-settings.js";


export default {
    name: 'layout',
    label: 'Veebilehe Seaded',
    i18n: {
        structure: 'single_file',
    },
    files: [navigation, footer, siteSettings, docsSettings],
};